import { TFunction } from "react-i18next"
import { InputModel } from "../../../../../../../utils/types"
import { Item } from "../../../../../../../utils/types/generals"

const filterList = ({ t }: { t: TFunction<"translation", undefined> }): Record<string, InputModel> => {
    return {
        area: {
            label: t('general.tags.areas'),
            name: 'area',
            type: 'filter-select',
            items: [],
        },
        department: {
            label: t('general.tags.departments'),
            name: 'department',
            type: 'filter-select',
            items: [],
        },
        userType: {
            label: t('general.tags.userType'),
            name: 'userType',
            type: 'filter-select',
            items: [],
        },
    }
}

const filterChildrenValue = ({ childrenValue, key, parentValue, }: { parentValue: Item[]; childrenValue: Item[]; key: string }) => {
    return childrenValue?.filter(child => parentValue?.some(parent => parent?.id == child?.[key]))
}
const filterChildrenItem = ({ childrenItem, key, parentValue, }: { parentValue: Item[]; childrenItem: Item[]; key: string }) => {
    return childrenItem?.filter(child => parentValue?.some(parent => parent?.id == child?.[key]))
}

export { filterList, filterChildrenValue, filterChildrenItem }
